(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cafeblow-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cafeblow-sticky-cart')) {
    customElements.define('cafeblow-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.observer) return;
          this.button = this.querySelector('button');
          this.original = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          const productInfo = this.closest('product-info');
          if (!this.button || !this.original || !productInfo?.contains(this.original)) return;
          this.onClick = () => {
            this.sync();
            if (!this.button.disabled) this.original.click();
          };
          this.button.addEventListener('click', this.onClick);
          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.original, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class', 'aria-haspopup'],
            childList: true,
            characterData: true,
            subtree: true,
          });
          this.sync();
          this.hidden = false;
        });
      }

      sync() {
        const variant = this.original.form?.querySelector('input[name="id"]');
        this.button.disabled = !this.original.isConnected || this.original.disabled ||
          this.original.getAttribute('aria-disabled') === 'true' || !variant?.value || variant.disabled;
        const label = this.original.querySelector('span')?.textContent.trim();
        if (label && this.button.textContent.trim() !== label) this.button.textContent = label;
        const popup = this.original.getAttribute('aria-haspopup');
        if (popup) this.button.setAttribute('aria-haspopup', popup);
        else this.button.removeAttribute('aria-haspopup');
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
